import { render, staticRenderFns } from "./FootContact.vue?vue&type=template&id=638f69cb&scoped=true&"
import script from "./FootContact.vue?vue&type=script&lang=js&"
export * from "./FootContact.vue?vue&type=script&lang=js&"
import style0 from "./FootContact.vue?vue&type=style&index=0&id=638f69cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638f69cb",
  null
  
)

export default component.exports